import React from "react";
import classes from "./index.module.scss";
import { Breadcrumb } from "antd";
import { Link } from "react-router-dom";
import useDeviceType from "Utils/useDeviceType";
import { SubLayout } from "../../../../components/Layouts/SubLayout";
import { SubLayoutHeader } from "../../../../components/Layouts/SubLayout/Component/SubLayoutHeader";

interface DetailLayoutProps {
    children: React.ReactNode;
    breadcrumb: string;
    mobileHeaderExtra?: React.ReactNode;
}

export default function EvaluateLayout({
    children,
    breadcrumb,
    mobileHeaderExtra
}: DetailLayoutProps) {
    const { isPC } = useDeviceType();

    return (
        <SubLayout className="PopupContainer">
            <SubLayoutHeader title="提交评价" extra={mobileHeaderExtra} />

            <div className={classes.main}>
                {isPC && (
                    <Breadcrumb separator=">">
                        <Breadcrumb.Item>
                            <Link to="/">首页</Link>
                        </Breadcrumb.Item>

                        <Breadcrumb.Item>{breadcrumb}</Breadcrumb.Item>
                    </Breadcrumb>
                )}

                <div className={classes.body}>{children}</div>
            </div>
        </SubLayout>
    );
}
